<script setup lang="ts">
import { onMounted } from 'vue';
import { useProductsStore } from './store/products';
import { useReceiversStore } from './store/receivers';
import { useStatusReasonStore } from './store/statusReason';
import { useDonorsStore } from './store/donors';
import Rollbar from './tools/rollbar?url';
import { initZendesk } from './tools/zendesk';
import { useEnviroment } from './composables';
import '@/assets/css/style.scss';

const productsStore = useProductsStore();
const receiversStore = useReceiversStore();
const donorsStore = useDonorsStore();
const statusReasonStore = useStatusReasonStore();

productsStore.fetchProductsWithCache();
receiversStore.fetchReceiversWithCache();
donorsStore.fetchDonorsWithCache();
statusReasonStore.fetchStatusReasonWithCache();

initZendesk();

onMounted(() => {
  if (import.meta.env.PROD && !useEnviroment().isStaging) {
    const scriptRollbar = document.createElement('script');
    scriptRollbar.setAttribute('src', Rollbar);
    document.head.appendChild(scriptRollbar);
  }
});
</script>

<template>
  <RouterView />
</template>
